import PropTypes from 'prop-types';
import * as ramda from 'ramda';
import React, { useCallback, useMemo } from 'react';
import { PopoverHeader } from 'reactstrap';
import Icon from '../../../common/containers/icon';
import SearchInput from '../../../common/search/searchInput';
const OptionActionsButtonHeader = _ref => {
  let _ref$evaluatedTitle = _ref.evaluatedTitle,
    evaluatedTitle = _ref$evaluatedTitle === void 0 ? null : _ref$evaluatedTitle,
    _ref$filterText = _ref.filterText,
    filterText = _ref$filterText === void 0 ? null : _ref$filterText,
    handleSearch = _ref.handleSearch,
    onBackSelect = _ref.onBackSelect,
    selected = _ref.selected;
  const popoverTitle = useMemo(() => {
    if (evaluatedTitle) return evaluatedTitle; // prefer evaluatedTitle
    if (selected.length === 0) return ' '; // blank space to render empty header
    return ramda.last(selected).title; // otherwise, use the title of the last selected option
  }, [evaluatedTitle, selected]);
  const backButton = selected.length === 0 ? ' ' : /*#__PURE__*/React.createElement("span", {
    className: "float-left",
    onClick: onBackSelect,
    onKeyPress: onBackSelect,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "chevron-left"
  }), selected.length >= 2
  // show the previous selection's title
  ? /*#__PURE__*/React.createElement("small", null, "\xA0", selected[selected.length - 2].title) : undefined);
  const handleClear = useCallback(async () => {
    await handleSearch(null);
  }, [handleSearch]);
  return /*#__PURE__*/React.createElement(PopoverHeader, {
    style: {
      minHeight: '32px'
    },
    className: "text-center"
  }, backButton, popoverTitle, popoverTitle === ' ' ? undefined : /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(SearchInput, {
    size: "sm",
    onChange: handleSearch,
    text: filterText || null,
    onClear: handleClear
  }));
};
OptionActionsButtonHeader.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  evaluatedTitle: PropTypes.string,
  filterText: PropTypes.string,
  onBackSelect: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired
  })).isRequired
};
export default OptionActionsButtonHeader;